import type { MediaItem } from '@/types'

/**
 * The card's metadata line: dimensions when known (they are not yet, APP-30),
 * else the file type from the URL. A video names its platform.
 */
export function mediaMeta(item: MediaItem): string {
  if (item.kind === 'video') {
    if (item.youtubeId) return 'YouTube'
    if (/vimeo\.com/i.test(item.url)) return 'Vimeo'
    return 'Video'
  }
  if (item.width && item.height) return `${item.width}×${item.height}`
  const ext = /\.([a-z0-9]{2,5})$/i.exec(pathname(item.url))?.[1]
  return ext ? ext.toUpperCase() : 'Image'
}

function pathname(url: string): string {
  try {
    return new URL(url).pathname
  } catch {
    return ''
  }
}
